import * as Sentry from '@sentry/browser';

export function init() {
    Sentry.init({
        ...window.SENTRY_SDK_CONFIG,

        integrations: [Sentry.browserTracingIntegration()],
    });
}
export default class Logger {
    error(message, extra = null) {
        if (extra) {
            Sentry.setContext('error context', {extra})
        }
        Sentry.captureMessage(message, 'error');
    }
}

